import { RefreshTokenInterceptorProvider } from './interceptors/refresh-token.interceptor';

export { RefreshTokenInterceptorProvider } from './interceptors/refresh-token.interceptor';

export const INTERCEPTORS: any[] = [
	RefreshTokenInterceptorProvider
];
